import { FuelRateBase } from './base/fuel-rate-base';

export class FuelRate extends FuelRateBase { }